var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormDisplay',{ref:"form",attrs:{"id":_vm.id,"inputs":_vm.inputs},on:{"onChange":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }